import { Compass } from 'lucide-react';
import { Link } from 'react-router-dom';
import { buttonClasses } from '../components/ui/Button';
import { EmptyState } from '../components/ui/Feedback';

export function NotFoundPage() {
  return (
    <EmptyState
      icon={<Compass className="h-6 w-6" />}
      title="Page not found"
      description="The page you are looking for does not exist."
      action={
        <Link to="/app" className={buttonClasses('primary')}>
          Back to dashboard
        </Link>
      }
    />
  );
}
